import { setCookie, getCookie } from "../modules/_utils";
import { blacklistedEmails } from "../modules/_utils";
console.log("gated-content.js loaded");

/**
 * Gated Content Verification System
 * Location: src/js/pages/script-gated-content.js
 * 
 * Requirements:
 * - Checks for "gated_content_logged_in" cookie (2 week TTL)
 * - Handles email verification, blacklisting, HubSpot API integration, and code validation
 * - Designed to be globally accessible in Sunrise theme
 */

const GATED_COOKIE = '4q1nMlJrjVHlYbLl3O4ohT4EH';
const CODE_COOKIE = 'TMAwJlfeUBI4ZHzBfaKFLuzVx';
const EMAIL_COOKIE = 'xvihcClQG8zEJ7nNaye8YAfHx';
const LOGGED_IN_COOKIE = 'user is successfully logged in';
const COOKIE_TTL_DAYS = 14;
let clickedElement = null;
let email = null;


// Utility: Generate random 6-digit code
function generateCode() {
    return Math.floor(100000 + Math.random() * 900000).toString();
}

// Utility: hash string
String.prototype.hashCode = function() {
  var hash = 0,
    i, chr;
  if (this.length === 0) return hash;
  for (i = 0; i < this.length; i++) {
    chr = this.charCodeAt(i);
    hash = ((hash << 5) - hash) + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}

// Utility: Show/hide elements
function show(el) { el.style.display = 'block'; }
function hide(el) { el.style.display = 'none'; }

// Utility: Simple API wrapper for HubSpot via WP AJAX endpoints

async function hubspotContactExists(email) {
    const formData = new FormData();
    formData.append('action', 'fetch_hubspot_user');
    formData.append('email', email);

    const res = await fetch('/wp-admin/admin-ajax.php', {
        method: 'POST',
        body: formData,
        credentials: 'same-origin'
    });
    const data = await res.json();
    
    if (data.success && data.data) {
        return { exists: true, contactId: data.data.hs_object_id || null };
    }
    return { exists: false, contactId: null };
}

async function hubspotUpdateContactWithCode(email, code) {
    const fields = [
        {
            name: 'email',
            value: email,
        },
        {
            name: 'gated_content_auth_code',
            value: code
        }
    ];

    const urlParams = new URLSearchParams(window.location.search);
    for (const [key, value] of urlParams.entries()) {
        if (key.toLowerCase().includes('utm')) {
            fields.push({
                name: key,
                value: value
            });
        }
    }

    // Grab the page title, URI, and hubspotutk cookie value to send along to HubSpot.
    var pageTitle = document.title;
    var pageUrl = document.URL;
    var hubSpotUtkCookie = getCookie('hubspotutk');

    const hsData = JSON.stringify({
        fields: fields,
        context: {
            hutk: hubSpotUtkCookie,
            pageUri: pageUrl,
            pageName: pageTitle
        },
        skipValidation: true
    });

    jQuery.ajax({
        "async": true,
        "crossDomain": true,
        "type": "POST",
        "url": `https://api.hsforms.com/submissions/v3/integration/submit/5133778/dfc9f844-405a-4e2a-9ad5-0e22aea76a58`,
        "headers": {
            "Content-Type": "application/json"
        },
        "data": hsData,
        "error": function (response) {
        },
        "success": function () {
        }
    });
}

async function hubspotCreateContact({ email, firstname, lastname, gated_content_auth_code }) {
    const fields = [
        { name: 'email', value: email },
        { name: 'firstname', value: firstname },
        { name: 'lastname', value: lastname },
        { name: 'gated_content_auth_code', value: gated_content_auth_code }
    ];

    const urlParams = new URLSearchParams(window.location.search);
    for (const [key, value] of urlParams.entries()) {
        if (key.toLowerCase().includes('utm')) {
            fields.push({
                name: key,
                value: value
            });
        }
    }

    // Grab the page title, URI, and hubspotutk cookie value to send along to HubSpot.
    var pageTitle = document.title;
    var pageUrl = document.URL;
    var hubSpotUtkCookie = getCookie('hubspotutk');

    const hsData = JSON.stringify({
        fields: fields,
        context: {
            hutk: hubSpotUtkCookie,
            pageUri: pageUrl,
            pageName: pageTitle
        },
        skipValidation: true
    });

    jQuery.ajax({
        "async": true,
        "crossDomain": true,
        "type": "POST",
        "url": `https://api.hsforms.com/submissions/v3/integration/submit/5133778/dfc9f844-405a-4e2a-9ad5-0e22aea76a58`,
        "headers": {
            "Content-Type": "application/json"
        },
        "data": hsData,
        "error": function (response) {
        },
        "success": function () {
        }
    });
}

// UI: Render forms and handle flow
function renderGatedContentModal() {
    // Modal HTML
    let modal = document.getElementById('gated-content-modal');
    show(modal);

    const modalCloses = modal.querySelectorAll('#gated-content-close');
    modalCloses.forEach(btn => {
        btn.onclick = () => {
            hide(modal);
            clickedElement = null; // Reset clicked element
        };
    });

    // Email form logic
    const emailForm = modal.querySelector('#gated-content-email-form');
    const extraForm = modal.querySelector('#gated-content-extra-form');
    const codeForm = modal.querySelector('#gated-content-code-form');
    const emailError = modal.querySelector('#gated-content-email-error');
    const extraError = modal.querySelector('#gated-content-extra-error');
    const codeError = modal.querySelector('#gated-content-code-error');

    emailForm.onsubmit = async (e) => {
        e.preventDefault();
        emailError.style.display = 'none';
        email = modal.querySelector('#gated-content-email').value.trim().toLowerCase();

        if (!email) {
            emailError.textContent = 'Please enter your email address.';
            show(emailError);
            return;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            emailError.textContent = 'Please enter a valid email address.';
            show(emailError);
            return;
        }
        // Blacklist check
        const emailDomain = email.split('@')[1];
        if (blacklistedEmails.includes(email) || blacklistedEmails.includes(emailDomain)) {
            emailError.textContent = 'Please enter your company email.';
            show(emailError);
            return;
        }

        // Check if contact exists
        const submitWrapper = emailForm.querySelector('.submit-wrapper');
        const btn = submitWrapper.querySelector('.btn');
        const spinner = submitWrapper.querySelector('.spinner');

        // Show spinner and disable button
        btn.value = "";
        btn.classList.add('disabled');
        show(spinner);

        const { exists } = await hubspotContactExists(email);

        // Hide spinner and enable button
        btn.classList.remove('disabled');
        hide(spinner);
        btn.value = "Continue";

        const code = generateCode();
        const hashedCode = code.hashCode().toString();
        const hashedEmail = email.hashCode().toString();
        setCookie(CODE_COOKIE, hashedCode, COOKIE_TTL_DAYS);
        setCookie(EMAIL_COOKIE, hashedEmail, COOKIE_TTL_DAYS);

        if (exists) {
            // Show spinner and disable button
            btn.value = "";
            btn.classList.add('disabled');
            show(spinner);

            await hubspotUpdateContactWithCode(email, code);

            // Hide spinner and enable button
            btn.classList.remove('disabled');
            hide(spinner);
            btn.value = "Continue";

            hide(emailForm);
            show(codeForm);
        } else {
            hide(emailForm);
            show(extraForm);

            extraForm.onsubmit = async (ev) => {
            ev.preventDefault();
            const extraSubmitWrapper = extraForm.querySelector('.submit-wrapper');
            const extraBtn = extraSubmitWrapper.querySelector('.btn');
            const extraSpinner = extraSubmitWrapper.querySelector('.spinner');

            extraBtn.value = "";
            extraBtn.classList.add('disabled');
            show(extraSpinner);

            const firstname = modal.querySelector('#gated-content-firstname').value.trim();
            const lastname = modal.querySelector('#gated-content-lastname').value.trim();
            emailError.style.display = 'none';
            if (!firstname || !lastname) {
                extraError.textContent = 'Please fill out all required fields.';
                show(extraError);

                extraBtn.classList.remove('disabled');
                hide(extraSpinner);
                extraBtn.value = "Continue";
                return;
            }
            await hubspotCreateContact({ email, firstname, lastname, gated_content_auth_code: code });

            extraBtn.classList.remove('disabled');
            hide(extraSpinner);
            extraBtn.value = "Continue";

            hide(extraForm);
            show(codeForm);
            };
        }
    };

    // Code form logic
    codeForm.onsubmit = (e) => {
        e.preventDefault();
        codeError.style.display = 'none';
        const inputCode = modal.querySelector('#gated-content-code').value.trim();
        const hashedInputCode = inputCode.hashCode().toString();
        const storedCode = getCookie(CODE_COOKIE);
        if (hashedInputCode === storedCode) {
            const hashedLoggedIn = LOGGED_IN_COOKIE.hashCode().toString();
            setCookie(GATED_COOKIE, hashedLoggedIn, COOKIE_TTL_DAYS);
            hide(modal);

            var _hsq = (window._hsq = window._hsq || []);
            _hsq.push([
                'identify',
                {
                    email: email,
                },
            ]);

            // Allow access to gated content
            if (clickedElement) {
                if (clickedElement.tagName === 'IMG') {
                    const parentLink = clickedElement.closest('a');
                    if (parentLink) {
                        clickedElement = parentLink;
                    }
                }
                // Add js-modal-trigger if data-resourcetype is 'video'
                if (clickedElement && clickedElement.getAttribute('data-resourcetype') === 'video') {
                    clickedElement.classList.add('js-modal-trigger');
                }
                if (clickedElement && clickedElement.getAttribute('data-resourcetype') === 'demo') {
                    clickedElement.classList.add('js-modal-trigger');
                }
                clickedElement.click(); // Trigger original click
            }
        } else {
            codeError.textContent = 'Invalid code. Please try again.';
            show(codeError);
        }
    };
}

// Main: Attach to all gated content links/buttons
function setupGatedContent() {
    document.querySelectorAll('[data-gated-content]').forEach(el => {
        el.addEventListener('click', (e) => {
            clickedElement = e.target;
            const hashedLoggedIn = LOGGED_IN_COOKIE.hashCode().toString();

            if (clickedElement.tagName === 'IMG') {
                const parentLink = clickedElement.closest('a');
                if (parentLink) {
                    clickedElement = parentLink;
                }
            }
            if (getCookie(GATED_COOKIE) === hashedLoggedIn) {
                // Allow access
                if (clickedElement && clickedElement.getAttribute('data-resourcetype') === 'video') {
                    clickedElement.classList.add('js-modal-trigger');
                }
                if (clickedElement && clickedElement.getAttribute('data-resourcetype') === 'demo') {
                    clickedElement.classList.add('js-modal-trigger');
                }
                // clickedElement.click(); // Trigger original click
            } else {
                e.preventDefault();
                e.stopPropagation();
                renderGatedContentModal();
            }
        });
    });

    // DEEP LINKING to specific resource if ?resource= is in URL
    if ( window.location.search){
        const params = new URLSearchParams(window.location.search);
    
        if ( params.get("resource") ){

            const query_value = params.get("resource"); // ?resource=
            
            // START if the slide is on page
            if ( document.querySelector(`#resources_results #${query_value}`) ) {
                const resource = document.querySelector(`#resources_results #${query_value}`);
                resource.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
                clickedElement = resource.firstElementChild;
                clickedElement.click();
            }
        } // if param resource
    }// if query
}

// Global init
document.addEventListener('DOMContentLoaded', setupGatedContent);

document.addEventListener('resourcesCarouselMounted', setupGatedContent);
// Export for global use if needed
window.GatedContent = {
    setup: setupGatedContent
};

function onArcadeIframeMessage(e) {
    if (e.origin !== 'https://demo.arcade.software' || !e.isTrusted) return;

    const arcadeIframe = document.querySelector(`iframe[src*="${e.data.id}"]`);
    if (!arcadeIframe || !arcadeIframe.contentWindow) return;

    if (e.data.event === 'arcade-init') {
        arcadeIframe.contentWindow.postMessage({event: 'register-popout-handler'}, '*');
    }

    if (e.data.event === 'arcade-popout-open') {
        arcadeIframe.style['position'] = 'fixed';
        arcadeIframe.style['z-index'] = '9999999';
    }

    if (e.data.event === 'arcade-popout-close') {
        arcadeIframe.style['position'] = 'absolute';
        arcadeIframe.style['z-index'] = 'auto';
    }
}

window.addEventListener('message', onArcadeIframeMessage);


